module.exports = {
  AFRAME_INJECTED: 'aframe-injected',
  animation: require('./animation')
};
